export class Common {
    // APIUrl:string="https://5thtrrt0nk.execute-api.ap-south-1.amazonaws.com/dev/admin"; // dev
    APIUrl:string="https://hgt2eqf0d7.execute-api.ap-south-1.amazonaws.com/prod/admin"; // prod
    PYAPI:string="http://magnuseducation.com:7000";
}
